import { FranchiseAdminsPage } from './franchise-admins/FranchiseAdminsPage'
import { FranchisesPage } from './franchises/FranchisesPage'

/**
 * `manager-platform` — the Control Tower's two screens inside the manager app.
 *
 * **Phase M's last two pages.** They were blocked from 2026-07-30 until 2026-07-31 on a super-admin
 * session: every endpoint behind them is `@RequireSuperAdmin`, which wants an RS256 tower token, and
 * `scripts/dev-token.sh` cannot mint one by design — *"a franchise's api-server holds only the public
 * key… nothing running inside a tenant can promote itself."*
 *
 * The owner chose `BLOCKED.md`'s first option: a **development** super-admin seeded into the local
 * central database by `scripts/dev-super-admin.sh`, which exists on the local stack and nowhere else and
 * is carried by no migration. The account signs in through `POST /central/auth/login` and the platform
 * mints its own token — so the asymmetry the security model rests on is untouched, and every finding
 * below is measured against the running server rather than read.
 *
 * The guard is `superAdminOnly`, which the shell's `RouteGate` already enforced for a route nobody had
 * yet written: the login answers `systemRole: "main_admin"` with `isSuperAdmin: true`, and a franchise's
 * own main admin — who is also `main_admin` — must not reach these screens. A `systemRoles` guard would
 * have admitted them.
 */
export const managerPlatformModule = {
  name: 'manager-platform',
  routes: [
    {
      path: '/franchises',
      page: 'franchises',
      guard: { superAdminOnly: true },
      component: FranchisesPage,
    },
    {
      path: '/franchise-admins',
      page: 'franchise-admins',
      guard: { superAdminOnly: true },
      component: FranchiseAdminsPage,
    },
  ],
} as const

export { FranchiseAdminsPage, FranchisesPage }
